import { UPDATE_MINI_CART_DETAILS } from './types';

export const updateMiniCartDetailsAction = (updateMiniCartDetails,actionType) => dispatch => {
    console.log('updateMiniCartDetails..in action',updateMiniCartDetails);
    dispatch({
        type: UPDATE_MINI_CART_DETAILS,
        updateMiniCartDetails: updateMiniCartDetails,
        actionType:actionType,
    })
}